module.exports = __webpack_public_path__ + "static/img/half-circle-3.471cf06c.svg";